export default function AttachmentIcon(props: Icon & { className?: string }) {
  const { height, width, className } = props;
  return (
    <svg
      className={className}
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="0 0 11.037 15"
    >
      <path
        fill="currentColor"
        d="M4.311 15a4.2 4.2 0 0 1-3.05-1.234 4.049 4.049 0 0 1-1.26-3.007V3.094a3.006 3.006 0 0 1 .9-2.181A2.94 2.94 0 0 1 3.082 0a2.974 2.974 0 0 1 2.2.9 3.018 3.018 0 0 1 .9 2.207v5.892h-1.1V3.094A1.9 1.9 0 0 0 4.5 1.686a2.036 2.036 0 0 0-2.833 0 1.9 1.9 0 0 0-.582 1.408v7.7a2.954 2.954 0 0 0 .947 2.225 3.192 3.192 0 0 0 2.286.9 3.068 3.068 0 0 0 1.069-.183 2.86 2.86 0 0 0 .9-.53v1.217a3.69 3.69 0 0 1-.921.426 3.573 3.573 0 0 1-1.043.148Zm3.006-3.15H6.049a.817.817 0 1 1 0-1.634h1.269V8.95a.817.817 0 1 1 1.634 0v1.27h1.268a.817.817 0 1 1 0 1.634H8.951v1.269a.817.817 0 1 1-1.634 0Zm-3.006-1v1.078a1.735 1.735 0 0 1-1.33-.574 1.975 1.975 0 0 1-.53-1.39V3.598a.5.5 0 0 1 .165-.391.567.567 0 0 1 .391-.148.536.536 0 0 1 .382.148.513.513 0 0 1 .156.391v6.414a.856.856 0 0 0 .217.591.7.7 0 0 0 .549.247Zm3.233-3.928V3.598a.534.534 0 0 1 .539-.539.567.567 0 0 1 .391.148.5.5 0 0 1 .165.391v3.32Z"
      />
    </svg>
  );
}
